<template>
  <div class="wheel-battle-teams-tab">
    <div class="section-header">
      <span class="section-title">{{ groupSummary }}</span>
      <span
        v-if="editable"
        class="edit-link"
        @click="onEditTeams"
      >
        编辑出赛球队
      </span>
    </div>

    <div v-if="teams.length" class="team-list">
      <div
        v-for="(team, index) in teams"
        :key="team.id"
        class="team-list-item"
      >
        <wheel-battle-team-row
          :team="team"
          :index="index"
          :show-index="true"
          :match-logo="matchLogo"
        >
          <template #action>
            <div
              class="jersey-link"
              :class="{ disabled: !jerseyEditable }"
              @click="onSelectJersey(team)"
            >
              <div
                v-if="team.clothesColor"
                class="jersey-color-dot"
                :style="{ backgroundColor: team.clothesColor }"
              />
              <span>{{ jerseyLabel(team) }}</span>
              <van-icon name="arrow" size="14" color="#c8c8c8" />
            </div>
          </template>
        </wheel-battle-team-row>
      </div>
    </div>

    <van-empty v-else description="暂无出赛球队" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon, Empty } from 'vant'
Vue.use(Icon).use(Empty)

import WheelBattleTeamRow from './WheelBattleTeamRow.vue'

export default {
  name: 'WheelBattleTeamsTab',
  components: {
    WheelBattleTeamRow
  },
  props: {
    parentGameId: {
      type: String,
      default: ''
    },
    unionMatchId: {
      type: String,
      default: ''
    },
    matchId: {
      type: String,
      default: ''
    },
    matchLogo: {
      type: String,
      default: ''
    },
    groupName: {
      type: String,
      default: ''
    },
    teams: {
      type: Array,
      default: function () {
        return []
      }
    },
    editable: {
      type: Boolean,
      default: true
    },
    jerseyEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    groupSummary: function () {
      var name = this.groupName || '小组'
      return name + ' ' + this.teams.length + '支球队'
    }
  },
  methods: {
    jerseyLabel: function (team) {
      if (team && team.clothesColor) {
        return ''
      }
      return '选择队服颜色 (可选)'
    },
    onEditTeams: function () {
      if (!this.editable) {
        return
      }
      this.$router.push({
        path: '/match-manage/wheel-battle/team-edit/' + this.parentGameId,
        query: {
          unionMatchId: this.unionMatchId,
          matchId: this.matchId,
          groupName: this.groupName,
          returnTab: 'teams'
        }
      })
    },
    onSelectJersey: function (team) {
      if (!this.jerseyEditable) {
        return
      }
      this.$emit('select-jersey', team)
    }
  }
}
</script>

<style scoped lang="scss">
.wheel-battle-teams-tab {
  background: #f1f1f1;
  min-height: 200px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f1f1f1;
}

.section-title {
  font-size: 14px;
  color: #333;
}

.edit-link {
  font-size: 14px;
  color: #2071b9;
}

.team-list {
  background: #fff;
}

.team-list-item {
  height: 50px;

  ::v-deep .team-action {
    align-self: stretch;
    display: flex;
    align-items: stretch;
    margin-right: -16px;
  }
}

.team-list-item + .team-list-item {
  border-top: 1px solid #f0f0f0;
}

.jersey-link {
  display: flex;
  align-items: center;
  min-height: 50px;
  padding: 0 16px 0 12px;
  font-size: 12px;
  color: #999999;
  white-space: nowrap;

  span {
    margin-right: 2px;
  }

  &.disabled {
    opacity: 0.6;
  }
}

.jersey-color-dot {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  border-radius: 50%;
  border: 1px solid #e5e5e5;
  flex-shrink: 0;
}
</style>
